module.exports = __webpack_public_path__ + "static/media/undraw_mcp-server_7kvc.dfe43c0a.svg";